import {
    COMPANY, LEADS, LEAD, CONNECTION
} from "./endpoints";
import API from "../utils/apiUtils";
import APIV2 from "../utils/apiV2Utils";
import { getPathParam, serialize } from "../utils/converter";

// detail
export const getLeads = ({ company_id, params, data, signal }) =>
    API.post(
        getPathParam([COMPANY, company_id, LEADS]) +
        (params ? serialize(params) : ""),
        data, { signal: signal }
    );


export const postLeads = ({ company_id, data }) =>
    API.post(getPathParam([COMPANY, company_id, LEAD]), data);

export const getLead = ({company_id, lead_id}) =>
    API.get(getPathParam([COMPANY, company_id, LEAD, lead_id ]));

export const convertLeadToCustomer = ({company_id, lead_id}) =>
    API.put(getPathParam([COMPANY, company_id, LEAD, lead_id, CONNECTION ]), {});

export const getRegistryLeads = ({ company_id, params, signal }) =>
    APIV2.get(getPathParam([COMPANY, company_id, LEADS]) + (params ? serialize(params) : ""), { signal });
